import { apiPathRegex } from "../config";

export default function apiPath(version: string | number) {
  return apiPathRegex.replace("%version%", `${version}`);
}
